class ProductController {
  constructor(subscriptionOrchestrator, $q) {
    this.subscriptionOrchestrator = subscriptionOrchestrator;
    this.$q = $q;
  }

  $onChanges({ item }) {
    if (item) {
      this.refresh();
    }
  }

  refresh() {
    this.loading = true;

    const noop = () => {};
    this.onItemLoaded = this.onItemLoaded || noop;

    let deferred = this.$q.defer();

    try {
      if (this.item.subscriptionId) {
        deferred = this.subscriptionOrchestrator.get(this.item.subscriptionId)
          .then((subscription) => {
            this.item.subscription = subscription;

            return this.item;
          });
      }
      else {
        deferred = this.$q.resolve(this.item);
      }
    }
    catch (err) {
      deferred = this.$q.reject(err);
    }

    return deferred.then((item) => {
      this.item = item;

      this.onItemLoaded(this.item);
    }).finally(() => {
      this.loading = false;
    });
  }
}

ProductController.$inject = ['subscriptionOrchestrator', '$q'];

module.exports = {
  module: angular.module('msi.products.product.controller', []).name,
  name: 'ProductController'
};

angular.module(module.exports.module)
  .controller(module.exports.name, ProductController);
